angular.module 'zc.projects', [
  'ngResource'
  'flow'
  'highcharts-ng'
  'zc.core'
  'zc.users'
  'zc.projects.campaigns'
  'zc.commonApi'
]




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/index.js.coffee